<script setup lang="ts">
interface Props {
  heading: string
  text?: string
  buttonText?: string
  fluidButton?: boolean
  asDialog?: boolean
}

defineProps<Props>()
const { hide, show, visible } = useVisible()

const { LocalConfigurationStore } = stores()
</script>
<template>
  <template v-if="LocalConfigurationStore?.brokerContext?.contact?.length">
    <template v-if="asDialog">
      <PvButton
        size="small"
        class="px-2 py-1 gap-1"
        :fluid="fluidButton"
        severity="warn"
        @click="show"
      >
        <span class="icon-[ph--info-bold]" />
        {{ buttonText ?? heading }}
      </PvButton>
      <PvDialog
        :header="heading"
        :show-header="false"
        class="max-w-[90%] md:w-[75rem]"
        :visible
      >
        <PvButton
          class="absolute aspect-square right-2 top-2 p-0"
          text
          @click="hide"
        >
          <span class="icon-[ph--x-bold] text-current" />
        </PvButton>
        <FormsGlobalAssistanceBody
          :heading
          :text
        />
      </PvDialog>
    </template>
    <template v-else>
      <CardComponent bg="light">
        <FormsGlobalAssistanceBody
          :heading
          :text
        />
      </CardComponent>
    </template>
  </template>
</template>
